import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const getExportFileData = createAsyncThunk(
  "order/exportFileData",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.getExportFile(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const exportFileDataSlice = createSlice({
  name: "exportFileData",
  initialState,
  reducers: {
    setExportFileData(state, action) {
      state.value = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExportFileData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getExportFileData.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(getExportFileData.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const exportFileDataResponse = (state) => state.orderExportFileData.value;
export const exportFileDataLoader = (state) => state.orderExportFileData.loading;
export const { setExportFileData } = exportFileDataSlice.actions;

export default exportFileDataSlice.reducer;

